import L from 'leaflet'
import 'leaflet.polylinemeasure'
import {createControlComponent} from '@react-leaflet/core'

function createMeasure(props) {
    const instance = L.control.polylineMeasure({position:'topleft', unit:'landmiles'})
    return instance
}

export const MeasureControl = createControlComponent(createMeasure)